import { IExchangeData } from '@src/types/exchange'
import { Balance } from '@src/utils/balance'

// Calculates and formats the exchange rate between two tokens with appropriate decimal precision
export const formatExchangePrice = (sellData: IExchangeData, buyData: IExchangeData, maxDecimals = 7): string => {
    const sn = new Balance(sellData.token).setValue(sellData.value).toNumber()
    const bn = new Balance(buyData.token).setValue(buyData.value).toNumber()

    const rate = bn / sn

    // If rate is 0 with maxDecimals, try more decimals
    let decimals = maxDecimals
    let formattedRate = rate.toFixed(decimals)

    // Keep adding decimals until we get a non-zero value or hit 10 decimals
    while (parseFloat(formattedRate) === 0 && decimals < 10) {
        decimals += 2
        formattedRate = rate.toFixed(decimals)
    }

    // If still 0 after 10 decimals, format with leading zeros notation
    if (parseFloat(formattedRate) === 0) {
        const scientificStr = rate.toExponential(2)
        const [num, exp] = scientificStr.split('e-')
        const zerosCount = parseInt(exp)
        return `0.₍${zerosCount}₎${num}`
    }

    // Remove trailing zeros after decimal point
    return formattedRate.replace(/\.?0+$/, '')
}
